import React from 'react';
import jet from "@randajan/jet-core";
import { list } from "@randajan/jet-core/eachSync";

import "./Reviews.scss";
import { usePromise } from '@randajan/jet-react';
import { Block } from '@randajan/jet-react/dom/block';

import { PagePop } from '../../../elements/PagePop/PagePop';
import { Apiform } from '../../../elements/Apiform/Apiform';
import { ReviewShort } from './Review/Review';
import { page } from '../../../config/base';
import { LinkGdpr } from '../../Docs/Gdpr/Gdpr';
import { bifrost } from '../../../config/bifrost';


export const Reviews = (props)=>{
    const {} = props;

    const { result:reviews, status, error } = usePromise([], _=>bifrost.tx("sunListReviews"), []);

    return (
        <Block className="Reviews block wall" caption="Jak nás vidí naši klienti" data-status={status}>
            <div className="scene">
                <div className="carousel">
                    {
                        list(
                            reviews,
                            r=><ReviewShort key={r.id} {...r} maxLength={150}/>,
                            {
                                orderBy:[[r=>r.priority, false], [r=>r.issued_at, false]]
                            }
                        )
                    }
                </div>
            </div>
            <PagePop caption={"Přidat vlastní zkušenost"} hash={"review"}>
                <Apiform name={"review"} caption={"Ohodnoťte nás!"} afterDone={_=>page.remove("hash.review")} note={<LinkGdpr/>}>
                    <Block caption="Dekujeme!">
                        <p>Vaše zkušenost je pro nás velice důležitá.</p>
                        <p>Děkujeme, že ji sdílíte s námi i s ostatními.</p>
                    </Block>
                </Apiform>
            </PagePop>
        </Block>
    )
}

